(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6547],{

/***/ 47342:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utilities/guidelines",
      function () {
        return __webpack_require__(58753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ FifthTip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _TipHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18423);
/* harmony import */ var _TipText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43369);




const FifthTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipHeading__WEBPACK_IMPORTED_MODULE_2__/* .TipHeading */ .p, {
                className: headingClassName,
                children: "Avoid copyrighted material"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                children: "Avoid copyrighted material or anything that might have to be cleared separately. All submissions will require a release indicating that you are solely responsible for the content."
            })
        ]
    });
};


/***/ }),

/***/ 82458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ SecondTip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _TipHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18423);
/* harmony import */ var _TipText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43369);




const SecondTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipHeading__WEBPACK_IMPORTED_MODULE_2__/* .TipHeading */ .p, {
                className: headingClassName,
                children: "Be entertaining and helpful"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                children: "Offer stories, tips and insights, and find ways to inspire other travelers to follow in your footsteps."
            })
        ]
    });
};


/***/ }),

/***/ 51084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ SeventhTip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _TipHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18423);
/* harmony import */ var _TipText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43369);




const SeventhTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipHeading__WEBPACK_IMPORTED_MODULE_2__/* .TipHeading */ .p, {
                className: headingClassName,
                children: "Leave no trace"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                className: "list-disc list-inside",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                            children: "Depictions of trashing our treasures are a no-go."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                            children: "Leave what you find. No touching or taking cultural, historical or natural artifacts."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                            children: "Respect wildlife. If you want to get gored by a bison – post that on TikTok."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                            children: "Be considerate of others."
                        })
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 19840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ SixthTip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _TipHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18423);
/* harmony import */ var _TipText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43369);




const SixthTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipHeading__WEBPACK_IMPORTED_MODULE_2__/* .TipHeading */ .p, {
                className: headingClassName,
                children: "Follow individual park guidelines"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                children: "Videos that depict irresponsible behavior will not be permitted."
            })
        ]
    });
};


/***/ }),

/***/ 57693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ThirdTip; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _TipHeading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18423);
/* harmony import */ var _TipText__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43369);




const ThirdTip = (param)=>{
    let { children , headingClassName  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("article", {
        className: "min-w-[300px]",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipHeading__WEBPACK_IMPORTED_MODULE_2__/* .TipHeading */ .p, {
                className: headingClassName,
                children: "Be concise"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TipText__WEBPACK_IMPORTED_MODULE_3__/* .TipText */ .o, {
                children: "One to 15 minutes should be enough, but if you’ve created something amazing, we’re happy to host longer pieces."
            })
        ]
    });
};


/***/ }),

/***/ 18423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ TipHeading; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const TipHeading = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("font-bold text-neutral-900 text-xl mb-4", className),
        children: children
    });
};


/***/ }),

/***/ 43369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ TipText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const TipText = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-sm text-neutral-800 !leading-[22px] inline", className),
        children: children
    });
};


/***/ }),

/***/ 58753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ guidelines; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/OutsidePageWrapper.tsx
var OutsidePageWrapper = __webpack_require__(55368);
// EXTERNAL MODULE: ../ui/src/components/Wrappers/InsidePageWrapper.tsx
var InsidePageWrapper = __webpack_require__(70996);
// EXTERNAL MODULE: ../ui/src/components/SimpleImage/index.tsx
var SimpleImage = __webpack_require__(86978);
// EXTERNAL MODULE: ../ui/src/components/Button/Button.tsx
var Button = __webpack_require__(57100);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/TipHeading.tsx
var TipHeading = __webpack_require__(18423);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/TipText.tsx
var TipText = __webpack_require__(43369);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/SecondTip.tsx
var SecondTip = __webpack_require__(82458);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/ThirdTip.tsx
var ThirdTip = __webpack_require__(57693);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/FifthTip.tsx
var FifthTip = __webpack_require__(21799);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/SixthTip.tsx
var SixthTip = __webpack_require__(19840);
// EXTERNAL MODULE: ./modules/Upload/VideoGuidelines/Tips/SeventhTip.tsx
var SeventhTip = __webpack_require__(51084);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next-auth@4.24.5_aqiqc4vv7pffmc2pmelp4wqb4e/node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(19266);
// EXTERNAL MODULE: ./modules/Config/ConfigContext.tsx
var ConfigContext = __webpack_require__(65729);
// EXTERNAL MODULE: ./modules/Auth/AuthContext.tsx
var AuthContext = __webpack_require__(35836);
// EXTERNAL MODULE: ./utils/useButtonsAnalytics.tsx
var useButtonsAnalytics = __webpack_require__(76356);
;// CONCATENATED MODULE: ./modules/Pages/GuidelinesPage/GuidelinesPage.tsx








const headingStyles = "mb-0 text-base lg:text-xl";
const GuidelinesPage = ()=>{
    (0,useButtonsAnalytics/* useButtonsAnalytics */.V)();
    const config = (0,ConfigContext/* useConfig */.ZR)();
    const { useSession  } = (0,AuthContext/* useAuth */.a)();
    const { data: session  } = useSession();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-white",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutsidePageWrapper/* OutsidePageWrapper */.d, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InsidePageWrapper/* InsidePageWrapper */.n, {
                className: "mb-[56px] lg:mt-[70px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-3xl mb-8 text-neutral-900 font-bold lg:mb-[72px] lg:text-[40px]",
                        children: "Video Guidelines"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col gap-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative w-[50px] h-[50px] mb-3 ",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleImage/* SimpleImage */.E, {
                                            src: "/media/illustrations/bulb.webp",
                                            alt: "Light bulb",
                                            fill: true,
                                            className: "object-contain"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TipHeading/* TipHeading */.p, {
                                        className: headingStyles,
                                        children: "We’re excited to have you join our Parks Channel creator community!"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TipText/* TipText */.o, {
                                        children: "Our goal is to create the most entertaining and informative video destination for parks content – and we can only do it with your help! The best videos will earn the chance to win Parks Channel swag, and when you decide to become a regular contributor, more opportunities will follow. We believe in rewarding great content!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondTip/* SecondTip */._, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ThirdTip/* ThirdTip */.D, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TipHeading/* TipHeading */.p, {
                                        className: headingStyles,
                                        children: "Make it pretty"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TipText/* TipText */.o, {
                                        children: "Shoot and edit something beautiful and exciting. You’ve got a whole movie studio in your smartphone!"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FifthTip/* FifthTip */.r, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SixthTip/* SixthTip */.Q, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SeventhTip/* SeventhTip */.j, {
                                headingClassName: headingStyles
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TipHeading/* TipHeading */.p, {
                                        className: headingStyles,
                                        children: "Send high quality material"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TipText/* TipText */.o, {
                                        children: [
                                            "Send us the full-resolution video file, with no compression. We want the highest quality we can get, and will compress on our side as needed.",
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TipText/* TipText */.o, {
                                        children: "It’s so easy to contribute. Now create your user profile and get started!"
                                    })
                                ]
                            })
                        ]
                    }),
                    session ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                        variant: "outline",
                        onClick: ()=>(0,next_auth_react.signIn)("cognito", {
                                callbackUrl: "".concat(config.pageUrl, "/videos/new")
                            }),
                        className: "mt-10",
                        children: "Sign In to submit a video"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./pages/utilities/guidelines.tsx

var __N_SSP = true;
/* harmony default export */ var guidelines = (GuidelinesPage);


/***/ }),

/***/ 76356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useButtonsAnalytics; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var _useAnalytics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24900);


const useButtonsAnalytics = ()=>{
    const { onButtonClick  } = (0,_useAnalytics__WEBPACK_IMPORTED_MODULE_1__/* .useAnalytics */ .z)();
    const listenEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((e)=>{
        if (!e || !e.target) return;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        onButtonClick(e.target.textContent);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!document) return;
        const buttons = document.querySelectorAll("button");
        buttons.forEach((button)=>button.addEventListener("click", listenEvent));
        return ()=>{
            buttons.forEach((button)=>button.removeEventListener("click", listenEvent));
        };
    }, []);
};


/***/ }),

/***/ 70996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ InsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const InsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className , id  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("mt-6 w-full max-w-6xl mx-auto", className),
        id: id,
        children: children
    });
};


/***/ }),

/***/ 55368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ OutsidePageWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83849);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);



const OutsidePageWrapper = (param)=>/*#__PURE__*/ {
    let { children , className  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-4 w-full max-w-screen-2xl mx-auto md:p-[30px] lg:p-10", className),
        children: children
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(47342); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);